export default __webpack_public_path__ + "static/media/cycle-disabled.deec4448.svg";